var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 350 360",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 4,
  strokeLinecap: "round",
  d: "M35.077 161.1H2M347.097 161.1H314.02"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-44.977 236.267 -293.3) skewX(.086)",
  stroke: "#fff",
  strokeWidth: 4,
  strokeLinecap: "round",
  d: "M2-2h33.049"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  transform: "matrix(.7074 .70682 .70788 -.70633 48.127 53.88)",
  stroke: "#fff",
  strokeWidth: 4,
  strokeLinecap: "round",
  d: "M2-2h33.049"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 4,
  strokeLinecap: "round",
  d: "M178.511 35.021V2.001"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M206.535 278.012c43.46-13.64 74.978-54.184 74.978-102.073 0-59.075-47.964-106.976-107.144-106.976-59.179 0-107.143 47.901-107.143 106.976 0 47.889 31.518 88.433 74.978 102.073h-11.528c-39.661-16.949-67.45-56.27-67.45-102.073 0-61.29 49.761-110.976 111.143-110.976 61.383 0 111.144 49.686 111.144 110.976 0 45.803-27.789 85.124-67.45 102.073h-11.528Z",
  fill: "#03B9DD"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M231.781 167.933v7.115l-15.254 2.559a42.176 42.176 0 0 1-3.207 11.13L224.849 199l-3.792 6.021-14.275-5.942a42.79 42.79 0 0 1-6.829 6.418l5.072 14.587-6.25 3.412-9.558-12.127a42.252 42.252 0 0 1-8.723 2.228l-2.562 15.227h-7.125l-2.552-15.227a42.144 42.144 0 0 1-8.841-2.263l-9.591 12.103-6.251-3.428 5.106-14.586a42.784 42.784 0 0 1-6.913-6.556l-14.313 5.848-3.753-6.037 11.602-10.194a42.13 42.13 0 0 1-3.095-10.877l-15.248-2.559v-7.115l15.254-2.559a42.166 42.166 0 0 1 3.207-11.13l-11.543-10.268 3.797-6.025 14.276 5.942a42.88 42.88 0 0 1 6.829-6.418l-5.072-14.587 6.259-3.403 9.557 12.127a42.189 42.189 0 0 1 8.723-2.228l2.562-15.227h7.125l2.562 15.225a42.144 42.144 0 0 1 8.841 2.263l9.592-12.103 6.24 3.43-5.106 14.586a42.697 42.697 0 0 1 6.913 6.556l14.313-5.849 3.753 6.037-11.602 10.195a42.16 42.16 0 0 1 3.096 10.877l15.247 2.559Z",
  stroke: "#03B9DD",
  strokeWidth: 3,
  strokeMiterlimit: 10
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M194.211 171.492c0 10.94-8.881 19.812-19.841 19.812s-19.841-8.872-19.841-19.812c0-10.94 8.881-19.812 19.841-19.812s19.841 8.872 19.841 19.812Z",
  stroke: "#03B9DD",
  strokeWidth: 3
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 123.752,
  y: 279.762,
  width: 103.401,
  height: 31.972,
  rx: 3.25,
  stroke: "#03B9DD",
  strokeWidth: 3.5
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M127.002 314.207h96.902a3.25 3.25 0 0 1 3.25 3.25v20.589a3.25 3.25 0 0 1-3.25 3.25h-23.139a6.75 6.75 0 0 0-6.75 6.75V355a3.25 3.25 0 0 1-3.25 3.25h-31.059a3.25 3.25 0 0 1-3.25-3.25v-6.969a6.75 6.75 0 0 0-6.75-6.75h-22.704a3.25 3.25 0 0 1-3.25-3.25v-20.574a3.25 3.25 0 0 1 3.25-3.25Z",
  stroke: "#03B9DD",
  strokeWidth: 3.5
})));
export default SvgLight;